import MoreIcon from "@shared/svg/three-dots-v2.svg?react";
import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuProvider,
  DropdownMenuTrigger,
} from "@shared/ui/DropdownMenu";
import { Eye, MinusCircle, PencilSimple, Trash } from "phosphor-react";
import React from "react";
import { useIntl } from "react-intl";

type Props = {
  onView?: () => void;
  onEdit?: () => void;
  onUnassign?: () => void;
  onDelete?: () => void;
};

const AssetRowActionsMenu: React.FC<Props> = ({
  onView,
  onEdit,
  onUnassign,
  onDelete,
}) => {
  const { messages } = useIntl();

  if (!onView && !onEdit && !onUnassign && !onDelete) {
    return null;
  }

  return (
    <DropdownMenuProvider>
      <DropdownMenuTrigger asChild>
        <div className="cursor-pointer p-xs">
          <MoreIcon className="w-lg h-lg" />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8}>
        {onView && (
          <DropdownMenuItem onSelect={onView}>
            <Eye className="w-lg h-lg flex-shrink-0" />
            {messages?.common?.view}
          </DropdownMenuItem>
        )}
        {onEdit && (
          <DropdownMenuItem onSelect={onEdit}>
            <PencilSimple className="w-lg h-lg flex-shrink-0" />
            {messages["hierarchy"]["assets"]["popupMenu"]["edit"]}
          </DropdownMenuItem>
        )}
        {onUnassign && (
          <DropdownMenuItem onSelect={onUnassign} className="text-danger">
            <MinusCircle className="w-lg h-lg flex-shrink-0 text-danger" />
            <span className="text-danger">
              {messages?.hierarchy?.["assets"]?.assetView?.unassignButtonText}
            </span>
          </DropdownMenuItem>
        )}
        {onDelete && (
          <DropdownMenuItem onSelect={onDelete} className="text-danger">
            <Trash className="w-lg h-lg flex-shrink-0 text-danger" />
            {messages["hierarchy"]["assets"]["popupMenu"]["delete"]}
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenuProvider>
  );
};

export default AssetRowActionsMenu;
